import { render, staticRenderFns } from "./AARItem.vue?vue&type=template&id=f146c088&scoped=true"
import script from "./AARItem.vue?vue&type=script&lang=js"
export * from "./AARItem.vue?vue&type=script&lang=js"
import style0 from "./AARItem.vue?vue&type=style&index=0&id=f146c088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f146c088",
  null
  
)

export default component.exports